<template>
  <div class="recharge_left capital_first" v-if="stablebaoStatus==1">
    <el-card class="box-card common-bg" shadow="never">
      <div slot="header" class="clearfix">
        <el-col :span="12">
            <h3>稳定币基金(GCNY) <span class="text_red_color">年化{{stable_interest_rate}}%</span></h3>
          </el-col>
      </div>
 <el-tabs>
        <el-tab-pane id="isFromCoupon3">
          <h4 slot="label"> 稳定币基金(GCNY)</h4>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row>
                 <el-col :span="5" style="text-align: center;line-height: 30px" class="common_border">
                  <h4>基金账户余额（GCNY)</h4>
                  <p class="text_red_color">{{ stable_account_balance }}</p>
                </el-col>

                <el-col :span="5" style="text-align: center;margin-left:20px;line-height: 30px" class="common_border">
                  <h4>申购额度 （GCNY)</h4>
                  <p class="text_red_color">{{ stable_account_avaialble_balance }}</p>
                </el-col>

                <el-col :span="5" style="margin-top:10px;text-align: center;margin-left:20px;"  class="common_border1">
                  <el-button type="warning"  @click="moveInState = true;" style="background-color: #D02E27;border:#D02E27">稳定币基金转入 </el-button>
            </el-col>
                  <el-col :span="5" style="margin-top:10px;text-align: center;margin-left:20px;"  class="common_border1">
                  <el-button type="warning"  @click="moveOutState = true;" style="background-color: #0D268D;border:#0D268D">稳定币基金转出  </el-button>
            </el-col>
               
           
              </el-row>
              <el-row style="padding-top:20px;">
                <el-col :span="5" style="text-align: center;line-height: 30px" class="common_border">
                  <h4>总持仓(GCNY)</h4>
                  <p class="text_red_color">{{ total_product_amount }}</p>
                </el-col>
                <el-col :span="5" style="text-align: center;margin-left:20px;line-height: 30px;" class="common_border">
                  <h4>最新日收益(GCNY)</h4>
                  <p class="text_red_color">{{ today_interest_amount }}</p>
                </el-col>
                <el-col :span="5" style="text-align: center;margin-left:20px;line-height: 30px;" class="common_border">
                  <h4>总收益（GCNY)</h4>
                  <p class="text_red_color">{{ total_interest_amount }}</p>
                </el-col>
                <el-col :span="5" style="margin-top:10px;text-align: center;margin-left:20px;"  class="common_border1">
                <p>GCNY:元=1:1</p>
                </el-col>

              </el-row>
            </div>
            <el-tabs>
        <el-tab-pane id="isFromCoupon1">
          <h4 slot="label"> 基金列表</h4>
          <el-card class="box-card">
             <div class="">
    <div class="product_lists common_border"
      v-for="(item, index) in stableProductLists"
      :key="index"
    >
      <div class="">
        <p class="font-semibold">{{ item.name }}</p>
        <p>{{ item.hours }} </p>
        <p class="text-sm">收益 {{ item.interest_amount }} %</p>
      </div>
      <div class="buy_button">
          <el-button type="danger"  @click="openBuyProductPopup(item)" style="background-color: #D02E27;border:#D02E27">买入 </el-button>
      </div>
    </div>
  </div>
      </el-card>
        </el-tab-pane>
        <el-tab-pane id="isFromCoupon2">
          <h4 slot="label"> 持仓列表</h4>
          <el-card>
          <el-table
            :data="userProudctLists.data"
            size="mini"
            stripe
            style="width: 100%">
            <el-table-column
              prop="name"
              align="center"
              label="产品">
            </el-table-column>
            <el-table-column
              prop="amount"
              align="center"
              label="金额">
            </el-table-column>
            <el-table-column
              prop="interest_amount"
              align="center"
              label="收益">
            </el-table-column>
      
               <el-table-column align="center" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status==0" style="color:grey"
                >等待到期</span
              >
              <span v-else-if="scope.row.status==1" style="color:#3F7A21">已到期</span>
              <span v-else style="color:#ED7D31">已赎回</span>
            </template>
            </el-table-column>
                 <el-table-column
                 width="150"
              prop="create_time"
              align="center"
              label="创建时间">
            </el-table-column>
                 <el-table-column
              prop="expire_time"
              align="center"
              label="到期时间"
               width="150">
            </el-table-column>
             <el-table-column label="操作" >
          <template slot-scope="scope">
            <el-button v-if="scope.row.status==0"size="mini" type="danger" style="background-color: #D02E27;border:#D02E27;margin-left: 20px;;"  @click="cancelOrderShowPopup(scope.row)">提前赎回</el-button>
          </template>
        </el-table-column>
          </el-table>
          <div class="changePage" style="padding-top: 15px;">
            <el-button type="primary" class="button_blue_color" icon="el-icon-arrow-left" @click="prevUserProductLists" size="mini">上一页</el-button>
            <el-button type="primary" class="button_blue_color" icon="el-icon-arrow-right" @click="nextUserProductLists" size="mini" style="float: right">
              下一页
            </el-button>
          </div>
          </el-card>
          <div style="margin-top: 25px; margin-bottom: 25px; color: #D02E27; font-weight: bold;text-align: center;">
          只显示最近12个月记录
        </div>
        </el-tab-pane>
          <el-tab-pane id="isFromCoupon4">
          <h4 slot="label"> 交易订单</h4>
          <el-card>
          <el-table
            :data="stableFlowLogs.data"
            size="mini"
            stripe
            style="width: 100%">
             <el-table-column
              prop="create_time"
              align="center"
              label="创建时间">
            </el-table-column>
            <el-table-column
              prop="type"
              align="center"
              label="流水类型">
            </el-table-column>
            <el-table-column
              prop="amount"
              align="center"
              label="金额">
            </el-table-column>
            <el-table-column
              prop="balance"
              align="center"
              label="稳定币基金金额">
            </el-table-column>
      
              
          </el-table>
          <div class="changePage" style="padding-top: 15px;">
            <el-button type="primary" class="button_blue_color" icon="el-icon-arrow-left" @click="prevStableFlowlogs" size="mini">上一页</el-button>
            <el-button type="primary" class="button_blue_color" icon="el-icon-arrow-right" @click="nextStableFlowlogs" size="mini" style="float: right">
              下一页
            </el-button>
          </div>
          </el-card>
          <div style="margin-top: 25px; margin-bottom: 25px; color: #D02E27; font-weight: bold;text-align: center;">
          只显示最近12个月记录
        </div>
        </el-tab-pane>

        <el-tab-pane id="isFromCoupon5">
          <h4 slot="label"> 申购额度明细</h4>
          <el-card>
          <el-table
            :data="availableBalanceFlowLogs.data"
            size="mini"
            stripe
            style="width: 100%">
             <el-table-column
              prop="create_time"
              align="center"
              label="创建时间">
            </el-table-column>
            <el-table-column
              prop="type"
              align="center"
              label="流水类型">
            </el-table-column>
            <el-table-column
              prop="amount"
              align="center"
              label="金额">
            </el-table-column>
            <el-table-column
              prop="balance"
              align="center"
              label="稳定币基金金额">
            </el-table-column>
      
              
          </el-table>
          <div class="changePage" style="padding-top: 15px;">
            <el-button type="primary" class="button_blue_color" icon="el-icon-arrow-left" @click="prevStableAvailableBalanceFlowlogs" size="mini">上一页</el-button>
            <el-button type="primary" class="button_blue_color" icon="el-icon-arrow-right" @click="nextStableAvailableBalanceFlowlogs" size="mini" style="float: right">
              下一页
            </el-button>
          </div>
          </el-card>
          <div style="margin-top: 25px; margin-bottom: 25px; color: #D02E27; font-weight: bold;text-align: center;">
          只显示最近12个月记录
        </div>
          
        </el-tab-pane>
   <el-tab-pane id="isFromCoupon6">
          <h4 slot="label"> 基金说明</h4>
          <el-card>
          <p v-html="stablebao_funding_description"></p>
          </el-card>  
        </el-tab-pane>

      </el-tabs>
          </el-card>
        </el-tab-pane>
      
      </el-tabs>
      
     
    </el-card>
<!--move in-->
    <el-dialog class="timebao_popup" title="转入到稳定币基金" :visible.sync="moveInState">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <h4 slot="label">账户余额:</h4>
          <p>{{ cash }} GCNY</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">转入金额:</h4>
          <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="moveInAmount" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="moveInState = false" >取消</el-button>
        <el-button type="primary" class="button_blue_color" @click="movein">确认</el-button>
      </div>
    </el-dialog>
    <!--move out-->

    <el-dialog class="timebao_popup" title="从稳定币基金转出" :visible.sync="moveOutState">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <h4 slot="label">可转余额:</h4>
          <p>{{ stable_account_balance }} GCNY</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">转出金额:</h4>
          <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="moveOutAmount" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="moveOutState = false">取消</el-button>
        <el-button type="primary" class="button_blue_color" @click="moveout">确认</el-button>
      </div>
    </el-dialog>
<!--buy producr-->
    <el-dialog class="buy_pro" title="买入产品" :visible.sync="buyProductState">
      <el-row style="margin-left:20px;margin-top:10px;margin-bottom: 15px;">
        <el-col :span="8">产品 : {{ buyProductName }}</el-col>
        <el-col :span="8">期间 : {{ buyProductDuration }}</el-col>
        <el-col :span="8">收益 : {{ buyProductInterest }}%</el-col>
      </el-row>
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <h4 slot="label">请输入金额 (GCNY):</h4>
          <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="buyProductAmount" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="buyProductState = false">取消</el-button>
        <el-button type="primary" class="button_blue_color" @click="buyProduct">确定</el-button>
      </div>
    </el-dialog>
    <!--cancel order-->
     <el-dialog class="buy_pro" title=" 提前赎回" :visible.sync="cancelOrderState" :show-close="false">
     <h4>您申购的基金到期还剩下 {{ expire_duration }}，提前赎回不享受收益，您确定要赎回吗？</h4>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelation">我再想想</el-button>
        <el-button type="primary" class="button_blue_color" @click="cancelOrder">提前赎回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    export default {
        name: "stable_coinbao",
      data(){
        return{
          
          moveInAmount:null,
          moveOutAmount:null,
          moveInState:false,
          moveOutState:false,
          userProudctLists: {
          date: [],
          data: [],
          page: 1,
          num: 20,
        },
         stableProductLists:null,
          stable_account_balance:0,
          stable_account_avaialble_balance:0,
          stable_account_buyable_balance:0,
          total_product_amount:0,
          total_interest_amount:0,
          today_interest_amount:0,
          stable_interest_rate:0,
          user_account_balance:0,
          buyProductState:false,
          buyProductAmount:null,
          productId:null,
          buyProductName:null,
          buyProductDuration:null,
          buyProductInterest:null,
          cancelOrderState:false,
          cancelOrderId:null,
           stableFlowLogs: {
          date: [],
          data: [],
          page: 1,
          num: 20,
        },
          availableBalanceFlowLogs: {
          date: [],
          data: [],
          page: 1,
          num: 20,
        },
        stablebaoStatus:0,
        stablebao_funding_description:'',
        expire_duration:null,
        timerInterval:null
        }
      },
      computed:{
      },
      methods: {
        cancelation(){
          this.cancelOrderState=false;
          this.stopTimer();
        },
        ExpireTimer(productDetail){
          let now = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Shanghai" }));        
          let expire = new Date(productDetail.expire_time.replace(/\./g, "-"));
          this.expire_duration=null;
        if (productDetail.status == 0 && expire >= now) {
          let diff = Math.floor((expire - now) / 1000); 
            if(diff<0){
          this.expire_duration=null;
            this.stopTimer();
            }else{
              let days = Math.floor(diff / 86400);
            let hours = Math.floor(diff % 86400 / 3600);
            let minutes = Math.floor(diff % 3600 / 60);
            let seconds = diff % 60;
            this.expire_duration = `${days ? days + " 天 " : ""}${hours ? hours + " 小时 " : ""}${minutes ? minutes + " 分 " : ""}${seconds ? seconds + " 秒" : ""}`;
      
            }
               }
        else{
          this.expire_duration=null;
          this.stopTimer();
        }
      },

        getStableFlowlogs(){
        let that = this;

        const requestData = {
          nozzle: "stable_coinbao_fund",
          token: sessionStorage.getItem("token"),
          action: "stable_coinbao_flow_log",
          page: that.stableFlowLogs.page,
          num: that.stableFlowLogs.num,
        };

        if (that.stableFlowLogs.date && that.stableFlowLogs.date.length === 2) {
          requestData.start = that.stableFlowLogs.date[0];
          requestData.end = that.stableFlowLogs.date[1];
        }

        that
          .$http({
            url: "/",
            method: "post",
            data: requestData
          })
          .then(function(res) {
            if (res.data.code == 1) {
              let resData = res.data;
              that.stableFlowLogs.data = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
        getAvailableBalanceFlowlogs(){
        let that = this;

        const requestData = {
          nozzle: "stable_coinbao_fund",
          token: sessionStorage.getItem("token"),
          action: "stable_coinbao_available_credit_details",
          page: that.availableBalanceFlowLogs.page,
          num: that.availableBalanceFlowLogs.num,
        };

        if (that.availableBalanceFlowLogs.date && that.availableBalanceFlowLogs.date.length === 2) {
          requestData.start = that.availableBalanceFlowLogs.date[0];
          requestData.end = that.availableBalanceFlowLogs.date[1];
        }

        that
          .$http({
            url: "/",
            method: "post",
            data: requestData
          })
          .then(function(res) {
            if (res.data.code == 1) {
              let resData = res.data;
              that.availableBalanceFlowLogs.data = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
         cancelOrder() {
            let that = this;
            that
            .$http({
                url: "/",
                method: "post",
                data: {
                nozzle: "stable_coinbao_fund",
                token: sessionStorage.getItem("token"),
                action: 'cancel_order',
                product_detail_id:that.cancelOrderId,
                }
            })
            .then(function (res) {
                if (res.data.code == 1) {
                  that.cancelOrderState = false;
                  that.$message({
                    message: res.data.msg,
                    type: 'success',
                    onClose:function () {
                    }
                  });
                  that.stopTimer();
                  that.mainMethod();
                } 
                else if (res.data.code == 0 || res.data.code == -1) {
                that.stopTimer();
                  that.$message.error(res.data.msg);
                }
            });
      },
        cancelOrderShowPopup(productDetail){
          let that=this;
          this.cancelOrderState=true;
          this.cancelOrderId=productDetail.id;
         
        if (this.timerInterval) clearInterval(this.timerInterval);
        that.ExpireTimer(productDetail);
      this.timerInterval = setInterval(() => {
        that.ExpireTimer(productDetail);
      }, 1000);
        },
         buyProduct() {
            let that = this;
            that
            .$http({
                url: "/",
                method: "post",
                data: {
                nozzle: "stable_coinbao_fund",
                token: sessionStorage.getItem("token"),
                action: 'buy_coinbao_product',
                product_id:that.productId,
                amount:that.buyProductAmount
                }
            })
            .then(function (res) {
                if (res.data.code == 1) {
                  that.buyProductState = false;
                  that.buyProductAmount=null;
                  that.$message({
                    message: res.data.msg,
                    type: 'success',
                    onClose:function () {
                    }
                  });
                  that.mainMethod();
                } 
                else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
                }
            });
      },
        openBuyProductPopup(productInfo){
          this.productId=productInfo.id;
          this.buyProductName=productInfo.name;
          this.buyProductDuration=productInfo.hours;
          this.buyProductInterest=productInfo.interest_amount;
          this.buyProductState=true;
        },
       getStableCoinbaoFund() {
            let that = this;
            that
            .$http({
                url: "/",
                method: "post",
                data: {
                nozzle: "stable_coinbao_fund",
                token: sessionStorage.getItem("token"),
                action: 'funds_product_list'
                }
            })
            .then(function (res) {
                if (res.data.code == 1) {
                let resData = res.data;
                that.stable_account_balance = resData.data.stable_account_balance;
                that.total_product_amount = resData.data.total_product_amount;
                that.total_interest_amount = resData.data.total_interest_amount;
                that.today_interest_amount = resData.data.today_interest_amount;
                that.stable_interest_rate = resData.data.stable_interest_rate;
                that.stableProductLists = resData.data.product_lists;
                that.user_account_balance=resData.data.user_account_balance;
                that.stable_account_avaialble_balance=resData.data.stable_account_avaialble_balance;
                that.stable_account_buyable_balance=resData.data.stable_account_buyable_balance;
                } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
                }
            });
      },
    getUserProductLists(){
        let that = this;

        const requestData = {
          nozzle: "stable_coinbao_fund",
          token: sessionStorage.getItem("token"),
          action: "user_product_list",
          page: that.userProudctLists.page,
          num: that.userProudctLists.num,
        };

        if (that.userProudctLists.date && that.userProudctLists.date.length === 2) {
          requestData.start = that.userProudctLists.date[0];
          requestData.end = that.userProudctLists.date[1];
        }

        that
          .$http({
            url: "/",
            method: "post",
            data: requestData
          })
          .then(function(res) {
            if (res.data.code == 1) {
              let resData = res.data;
              that.userProudctLists.data = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
      //获取用户信息
    getUserinfo() {
      let that = this;
      that.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "user",
          token: sessionStorage.getItem("token")
        }
      })
        .then(function (res) {
          if (res.data.code == 1) {
            that.cash = res.data.data.cash;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
      prevUserProductLists(){
          let page = this.userProudctLists.page;
          if (page == 1){
            this.$message({
              message: '已经是第一页',
              type: 'warning'
            });
          }else{
            this.userProudctLists.page = page-1;
            this.getUserProductLists();
          }
        },
    nextUserProductLists(){
          let page = this.userProudctLists.page;
          if ( this.userProudctLists.data.length < 20){
            this.$message({
              message: '已经是最后一页',
              type: 'warning'
            });
          }else{
            this.userProudctLists.page = page+1;
            this.getUserProductLists();
          }
        },
    movein(){
        let that = this;
        let money = that.moveInAmount;
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "stable_coinbao_fund",
                  token: sessionStorage.getItem("token"),
                  action: 'movein',
                  amount: money,
                }
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.moveInState = false;
                  that.moveInAmount=null;
                  that.$message({
                    message: res.data.msg,
                    type: 'success',
                    onClose:function () {
                      // that.mainMethod();
                    }
                  });
                  that.mainMethod();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                }
              });
          
      },
    moveout(){
        let that = this;
        let money = that.moveOutAmount;
        that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "stable_coinbao_fund",
                  token: sessionStorage.getItem("token"),
                  action: 'moveout',
                  amount: money,
                }
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.moveOutState = false;
                  that.moveOutAmount=null;
                  that.$message({
                    message: res.data.msg,
                    type: 'success',
                    onClose:function () {
                      // that.mainMethod();
                    }
                  });
                  that.mainMethod();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                }
              });
      },
      prevStableFlowlogs(){
          let page = this.stableFlowLogs.page;
          if (page == 1){
            this.$message({
              message: '已经是第一页',
              type: 'warning'
            });
          }else{
            this.stableFlowLogs.page = page-1;
            this.getStableFlowlogs();
          }
        },
    nextStableFlowlogs(){
          let page = this.stableFlowLogs.page;
          if ( this.stableFlowLogs.data.length < 20){
            this.$message({
              message: '已经是最后一页',
              type: 'warning'
            });
          }else{
            this.stableFlowLogs.page = page+1;
            this.getStableFlowlogs();
          }
        },
         prevStableAvailableBalanceFlowlogs(){
          let page = this.availableBalanceFlowLogs.page;
          if (page == 1){
            this.$message({
              message: '已经是第一页',
              type: 'warning'
            });
          }else{
            this.availableBalanceFlowLogs.page = page-1;
            this.getAvailableBalanceFlowlogs();
          }
        },
    nextStableAvailableBalanceFlowlogs(){
          let page = this.availableBalanceFlowLogs.page;
          if ( this.availableBalanceFlowLogs.data.length < 20){
            this.$message({
              message: '已经是最后一页',
              type: 'warning'
            });
          }else{
            this.availableBalanceFlowLogs.page = page+1;
            this.getAvailableBalanceFlowlogs();
          }
        },
         getSysConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "stablebao_status",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            let resData = res.data;
            that.stablebaoStatus = resData.data;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
         getStablebaoDescription() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "stablebao_funding_description",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            let resData = res.data;
            that.stablebao_funding_description = resData.data;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
      mainMethod(){
        this.getStableCoinbaoFund();
        this.getUserProductLists();
        this.getUserinfo();
        this.getStableFlowlogs();
      },
stopTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
      },
    },
  beforeDestroy() {
    this.stopTimer();

},
      created() {
      },
      mounted () {
        this.getSysConfig();
        this.getStablebaoDescription();
        this.getStableCoinbaoFund();
        this.getUserProductLists();
        this.getUserinfo();
        this.getStableFlowlogs();
        this.getAvailableBalanceFlowlogs();
      },
      beforeDestroy() {
        
      },
    }
</script>

<style scoped>
   /deep/ .el-tabs__item.is-active {
       color: #0D268D !important;
   }
   /deep/ .el-tabs__item:hover {
color: #0D268D !important;
}
/deep/ .el-tabs__active-bar{
background-color:#0D268D !important;
}
/deep/ .common_border1{
   padding:15px !important;
}
</style>

<style>
.timebao_popup .el-dialog{
    width: 20% !important;
}
.buy_button{
float:right !important;
margin-top:-50px;
}
.product_lists{
  padding:10px;
  margin-top:10px;
}
.buy_pro .el-dialog{
    width: 25% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/stableCoinbao.vue